import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import config from 'modules/config';

import useI18n from 'hooks/I18n/useI18n';

import Text from 'components/ProductIdentity/Text.jsx';
import { XSMALL_SIZE } from 'src/components/atoms/Button/Button.jsx';
import Link, { DISPLAY_MODES } from 'src/components/atoms/Link/Link.jsx';

const ALMBanner = ({ hasProductsButton, deliveryDates, distributionId, className, onSalePage }) => {
    const { trans } = useI18n();
    return (
        <div className={classNames('alm-banner', className)}>
            <div className="alm-banner-flex">
                <div>
                    <Text weight={700} size="16px" lineHeight="24px" color="turquoise2">
                        {trans('alm.sale.banner.title')}
                    </Text>
                    <ul>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('alm.sale.banner.item1')}
                            </Text>
                        </li>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('alm.sale.banner.item2')}
                            </Text>
                        </li>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('alm.sale.banner.item3')}
                            </Text>
                        </li>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('alm.sale.banner.item4')}
                            </Text>
                        </li>
                    </ul>
                    {hasProductsButton && (
                        <Link
                            bypassRouter
                            className={XSMALL_SIZE}
                            href={`assemblies/${config.CROWDFARMING_HIVE_ID}/collections/${distributionId}/products`}
                            displayMode={DISPLAY_MODES.BUTTON}
                        >
                            {trans('alm.sale.banner.discover')}
                        </Link>
                    )}
                </div>
                <div>
                    {onSalePage ? (
                        <img src="/assets/images/banners/alm-sale-page-mango.png"></img>
                    ) : (
                        <img src="/assets/images/banners/alm-mango.png"></img>
                    )}
                </div>
            </div>
            {deliveryDates && <Text className="delivery-dates">{deliveryDates}</Text>}
        </div>
    );
};

ALMBanner.propTypes = {
    hasProductsButton: PropTypes.bool,
    deliveryDates: PropTypes.string,
    distributionId: PropTypes.number,
    className: PropTypes.string,
    onSalePage: PropTypes.bool,
};

ALMBanner.defaultProps = {
    hasProductsButton: false,
    deliveryDates: '',
    className: '',
    onSalePage: false,
};

export default ALMBanner;
